"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.deleteParams = deleteParams;
_Object$defineProperty(exports, "flattenPairsArray", {
  enumerable: true,
  get: function () {
    return _pairs2.flattenPairsArray;
  }
});
_Object$defineProperty(exports, "flattenedPairsToQueryString", {
  enumerable: true,
  get: function () {
    return _pairs2.flattenedPairsToQueryString;
  }
});
exports.getParameterByName = getParameterByName;
_Object$defineProperty(exports, "objectToPairsArray", {
  enumerable: true,
  get: function () {
    return _pairs2.objectToPairsArray;
  }
});
_Object$defineProperty(exports, "pairsArrayToObject", {
  enumerable: true,
  get: function () {
    return _pairs2.pairsArrayToObject;
  }
});
_Object$defineProperty(exports, "parseQueryParam", {
  enumerable: true,
  get: function () {
    return _pairs2.parseQueryParam;
  }
});
_Object$defineProperty(exports, "queryStringToFlattenedPairsArray", {
  enumerable: true,
  get: function () {
    return _pairs2.queryStringToFlattenedPairsArray;
  }
});
exports.queryStringToObject = queryStringToObject;
_Object$defineProperty(exports, "queryStringToPairsArray", {
  enumerable: true,
  get: function () {
    return _pairs2.queryStringToPairsArray;
  }
});
exports.toQueryString = toQueryString;
var _isArray = _interopRequireDefault(require("@babel/runtime-corejs3/core-js/array/is-array"));
var _url = _interopRequireDefault(require("@babel/runtime-corejs3/core-js/url"));
var _filter = _interopRequireDefault(require("@babel/runtime-corejs3/core-js/instance/filter"));
var _find = _interopRequireDefault(require("@babel/runtime-corejs3/core-js/instance/find"));
var _indexOf = _interopRequireDefault(require("@babel/runtime-corejs3/core-js/instance/index-of"));
var _pairs = require("../../pairs");
var _pairs2 = require("./pairs");
/**
 * Convert a query string to an object. Defaults to the current browser location query string
 *
 * @param  {String} queryString Optional query string to convert
 * @return {Object}
 */
function queryStringToObject(queryString = window.location.search) {
  return (0, _pairs2.pairsArrayToObject)((0, _pairs2.queryStringToPairsArray)(queryString));
}

/**
 * Serializes an object or pairs array into a query string
 * @param  {Object} params Object to serialize
 * @return {String}        Query parameter
 */
function toQueryString(params) {
  const pairs = (0, _isArray.default)(params) ? params : (0, _pairs2.objectToPairsArray)(params);
  return (0, _pairs2.flattenedPairsToQueryString)((0, _pairs2.flattenPairsArray)(pairs));
}

/**
 * Removes query string parameters with keys contained in paramKeys
 * @param  {Object} paramsToDelete             Parameter keys or keys/values to remove
 * @param  {String} [url=window.location.href] The URL to remove from
 * @return {String}                            The Modified URL
 */
function deleteParams(paramsToDelete, url = window.location.href) {
  url = new _url.default(url, window.location.href);
  let pairs = (0, _pairs2.queryStringToFlattenedPairsArray)(url.search);
  if (!(0, _isArray.default)(paramsToDelete)) {
    paramsToDelete = (0, _pairs2.objectToPairsArray)(paramsToDelete);
  }
  if ((0, _pairs.isPairsArray)(paramsToDelete)) {
    paramsToDelete = (0, _pairs2.flattenPairsArray)(paramsToDelete, '', null);
    pairs = (0, _filter.default)(pairs).call(pairs, pair => {
      const matchingParam = (0, _find.default)(paramsToDelete).call(paramsToDelete, paramToDelete => paramToDelete.name === pair.name && paramToDelete.value === pair.value);
      return !matchingParam;
    });
  } else if ((0, _isArray.default)(paramsToDelete)) {
    pairs = (0, _filter.default)(pairs).call(pairs, pair => (0, _indexOf.default)(paramsToDelete).call(paramsToDelete, pair.name) === -1);
  } else {
    throw new Error(`Expected pairs array, object hash, or array of strings but instead got ${typeof paramsToDelete}`);
  }
  url.search = (0, _pairs2.flattenedPairsToQueryString)(pairs);
  return url.toString();
}

/**
* Get the value of a url parameter
*
* @param {String} name the url parameter
* @return {String|false} the value of the parameter
*/
function getParameterByName(name, queryString = window.location.search) {
  name = name.replace(/[[]/, "\\[").replace(/[\]]/, "\\]");
  const val = queryStringToObject(queryString)[name];
  if (val === '') {
    return true;
  }
  if (typeof val === 'undefined') {
    return false;
  }
  return val;
}